export function removeFromSessionStorage(keys: string[] | readonly string[]): void {
  keys.forEach((key) => {
    sessionStorage.removeItem(key);
  });
}
